<template>
  <v-form>
    <v-container>
      <Menu></Menu>
      <v-layout>  

      <v-flex v-if="acitveSubscription != null" v-bind:class= "[$vuetify.breakpoint.smAndDown ? [] : ['d-flex', 'margin-t']]" wrap>
        <v-flex v-if="acitveSubscription" xs12 md7 style="padding-top:20px; height:auto; ">
          <h1>Billing<br/></h1>
          <h4>Smartpress core subscription active</h4>
          <h5>Valid until <strong>{{validTo}}</strong></h5>
          <span>For support, billing changes and cancellations, please email lachlan@smartpress.co</span>




<!--      <table>
            <tr>
              <th>Item</th>
              <th>Price per month</th>
              <th>Yearly total</th>
            </tr>
            <tr>
              <td>1 x Smartpress core 12 month subscription</td>
              <td>$12 / month</td>
              <td>$168 / year</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>Total</td>
              <td>$168 AUD</td>
            </tr>
          </table> -->

          

        </v-flex>
        <v-flex v-else xs12 md5   style=" height:300px;padding:20px;">

          <h1>Billing<br/></h1>
          <h4>Current plan: Free trial</h4>

          <v-btn to="/billingInfoVip">Upgrade now</v-btn>
          
          
        </v-flex> 
      </v-flex>
    </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import Menu from '../../components/Menu'
  import { mapState } from 'vuex'
  import store from "@/store"

  export default {
  created: function () {
    this.initCheckout()
  },
  components: {
    Menu
  },
  data: () => ({

    acitveSubscription: null,
    validTo: '',
    
  }),
  methods: {
    initCheckout: function () {



      this.$store.dispatch("payments/getUserBilling")
      .then((res) => {

        if (res.data.Count > 0) {
          var date = new Date(+res.data.Items[0].created.S); 
          this.acitveSubscription = true
          this.validTo = date.toString().substr(0, 15)
        } else {
          this.acitveSubscription = false
        }
        console.log(res)
      }) 
    }
  },

  computed: {
        ...mapState({
          billingInfo: state => state.payments.billingInfo, 
        }),
      },
}
</script>

          <style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid rgba(0,0,0,0.04);
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: rgba(0,0,0,0.04);
}
</style>